import jQuery from 'jquery';

export const StickyObserver = {
  options: {
    position: 'top',
    stickyClass: 'sticky',
    root: null,
    rootMargin: '0px',
  },

  _create: function () {
    if (IntersectionObserver) {
      const sentinel = jQuery('<div class="sticky-sentinel" style="position: absolute; left: 0; right: 0; height: 1px; visibility: hidden">');
      const position = this._getPosition();
      if (position === 'top') {
        sentinel.insertBefore(this.element);
      }
      else {
        sentinel.insertAfter(this.element);
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const sentinelRect = entry.boundingClientRect;
          const rootBounds = entry.rootBounds;

          if (position === 'top') {
            this._setState(sentinelRect.bottom < rootBounds.top);
          }
          else {
            this._setState(sentinelRect.top > rootBounds.bottom);
          }
        });
      }, {
        root: this.options.root,
        rootMargin: this.options.rootMargin,
      });
      observer.observe(sentinel[0]);
    }
  },

  _setState: function (isSticky, entry) {
    this.element.toggleClass(this.options.stickyClass, isSticky);
    this.element.trigger({type: 'sticky', isSticky, entry}, [isSticky]);
  },

  _getPosition: function () {
    if (this.element.css('top') !== 'auto') {
      return 'top';
    }
    if (this.element.css('bottom') !== 'auto') {
      return 'bottom';
    }
    return this.options.position;
  }
};
